<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
    <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
